import { ReleaseHighlight } from "@/entities/release-highlight";
import { Dialog, DialogBody, DialogContainer, DialogDescription, DialogHeader, DialogTitle } from "@/shared/components";
import { Markdown } from "@/shared/components/markdown/markdown.tsx";
import { formatDateRelative } from "@/shared/utils";

type ReleaseHighlightDialogProps = {
    bericht: ReleaseHighlight | null;
    onClose: () => void;
};

export function ReleaseHighlightDialog({ bericht, onClose }: Readonly<ReleaseHighlightDialogProps>) {
    return (
        <Dialog open={!!bericht} onOpenChange={(open) => !open && onClose()}>
            {bericht && (
                <DialogContainer className="max-w-184" data-testid="release-highlight-dialog">
                    <DialogHeader>
                        <DialogTitle>{bericht.titel}</DialogTitle>
                        <DialogDescription>{formatDateRelative(bericht.datum)}</DialogDescription>
                    </DialogHeader>
                    <DialogBody>
                        <Markdown markdown={bericht.volledigeOmschrijving} />
                    </DialogBody>
                </DialogContainer>
            )}
        </Dialog>
    );
}
